import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../components/buttons/customButton';
import { useUpdateOnboardingStep } from '../../../apiHooks/mutations/onboarding/useUpdateOnboardingStep';

interface CompleteStepProps {
  onFinish: () => void;
}

const CompleteStep: FC<CompleteStepProps> = ({ onFinish }) => {
  const { t } = useTranslation();
  const { mutateAsync: updateStep, isLoading } = useUpdateOnboardingStep();

  const handleFinish = async () => {
    await updateStep({ step: 'complete', status: 'completed' });
    onFinish();
  };

  return (
    <div className="flex w-full max-w-3xl flex-col gap-6">
      <div className="rounded-2xl border border-gray-100 bg-white p-8 shadow-sm">
        <div className="mb-5 flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green/10">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-green">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
        </div>

        <h1 className="mb-2 text-center text-lg font-semibold text-gray-900">
          {t('setup.complete.title')}
        </h1>
        <p className="mb-2 text-center text-sm leading-relaxed text-gray-500">
          {t('setup.complete.subtitle')}
        </p>
        <p className="text-center text-sm leading-relaxed text-gray-500">
          {t('setup.complete.message')}
        </p>
      </div>

      <CustomButton
        className="w-full justify-center py-2.5"
        disabled={isLoading}
        onClick={handleFinish}
      >
        {isLoading ? t('setup.saving') : t('setup.complete.finishButton')}
      </CustomButton>
    </div>
  );
};

export default CompleteStep;
